import { useIntl } from 'react-intl';
import type { RatingStarsProps } from '@packages/shared/src/ui/Rating/RatingStars';
import { RatingStars } from '@packages/shared/src/ui/Rating/RatingStars';
import { customerRatingIconsWithReviewCountMessages } from './CustomerRatingIconsWithReviewCount.messages';
import { CustomerRatingsCount } from '../CustomerRatingsCount/CustomerRatingsCount';
import { maximumRatingAmount } from '../config';

export type CustomerRatingIconsWithReviewCountProps = RatingStarsProps & {
  ratingsCount: number;
  isLinked?: boolean;
};

/**
 * Shows Rating Icons and the amount of given ratings
 * */
export const CustomerRatingIconsWithReviewCount = ({
  ratingValue,
  ratingsCount,
  isLinked = false,
  ...props
}: CustomerRatingIconsWithReviewCountProps) => {
  const { formatMessage } = useIntl();

  const ariaLabelText = formatMessage(
    ratingValue && ratingsCount
      ? customerRatingIconsWithReviewCountMessages.ariaLabel
      : customerRatingIconsWithReviewCountMessages.ariaLabelZero,
    { ratingValue: ratingValue?.toFixed(2), maxRating: maximumRatingAmount, ratingsCount },
  );

  return (
    <div className="flex flex-row items-center gap-1" aria-label={ariaLabelText} {...props}>
      <RatingStars ratingValue={ratingValue} />
      {ratingsCount > 0 && (
        <CustomerRatingsCount ratingsCount={ratingsCount} isLinked={isLinked} type="icons" />
      )}
    </div>
  );
};
